import { cordinateToDegree } from "./cordinateToDegree";

export const googleMapUrl = (lng, lat, zoom = 16) => {
 let degreeLng = cordinateToDegree(lng);
 let degreeLat = cordinateToDegree(lat);
 return `https://www.google.com/maps/place/${degreeLng.degree}%C2%B0${degreeLng.minutes}'${degreeLng.second}%22N+${degreeLat.degree}%C2%B0${degreeLat.minutes}'${degreeLat.second}%22E/@${lng},${lat},${zoom}z/data=!4m5!3m4!1s0x0:0x6f40d6283969601f!8m2!3d${lng}!4d${lat}`;
};
